var _path, _path2, _polygon, _path3, _polygon2, _path4, _circle, _path5, _polygon3, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _rect2, _path11, _circle2, _path12, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path13, _path14, _path15, _path16, _path17, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path18, _path19, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect32, _rect33, _rect34, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a4d9ce11-c706-4741-be3d-81ae8fde7cf6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 949.01604,
    height: 767.11599,
    viewBox: "0 0 949.01604 767.11599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M882.70791,318.96123l-80.03438,1a5.67285,5.67285,0,0,1-5.66646-5.66646V287.85129a42.18365,42.18365,0,1,1,84.3673,0l7,25.44348A5.67285,5.67285,0,0,1,882.70791,318.96123Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M921.89072,549.5866a12.28744,12.28744,0,0,1,.72533-18.82737l-13.92733-41.38481,21.93775,5.79748,9.86232,38.4109a12.354,12.354,0,0,1-18.59807,16.0038Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "701.503 749.358 685.075 746.693 687.539 682.062 711.784 685.996 701.503 749.358",
    fill: "#ffb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M828.60089,832.40356l-52.96835-8.59439.10868-.67a20.88749,20.88749,0,0,1,23.96124-17.27214l.00131.00021,32.35125,5.24927Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "780.006 711.723 765.148 719.219 729.162 665.477 751.091 654.413 780.006 711.723",
    fill: "#ffb6b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M916.55458,790.65527l-47.90848,24.172-.30576-.606a20.88751,20.88751,0,0,1,9.238-28.0558l.00119-.00059,29.26092-14.76336Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 713.34914,
    cy: 224.03212,
    r: 29.21263,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M861.97279,760.76733l-68.4171-174.4564c-24.4861-66.885-2.608-112.98252-2.38426-113.44029l.1093-.22344.23312-.08516c2.59291-.95117,63.75939-23.07263,86.893-3.641,8.521,7.157,14.07609,20.99757,16.51078,41.13638a158.85646,158.85646,0,0,1-5.65659,64.32979l-26.95068,91.35869,33.34223,75.11152Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "703.489 586.116 678.782 711.381 711.687 717.585 732.387 609.157 703.489 586.116",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M860.38739,333.94989l-37.76928.50346-33.06182,7.60524,1.95939,132.42378s59.776,16.91222,86.03112-6.47546l17.31737-123.94305Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e4e4e4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M885.40986,351.91115l9.45431-7.84729s8.40625,2.48467,14.277,19.042,29.92248,148.84171,29.92248,148.84171l-25.90184,12.02585-35.076-116.91076Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M677.85072,509.448a12.28742,12.28742,0,0,1,15.95812-10.0167l26.326-34.83695,7.58148,21.38683-26.162,29.80292a12.354,12.354,0,0,1-23.70366-6.3361Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M799.37874,350.061l-9.45431-7.84729s-8.40625,2.48467-14.277,19.042S694.8463,488.82089,694.8463,488.82089l25.90184,12.02586,85.95464-95.63425Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e4e4e4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M728.2085,306.75264q-.494-2.58944-1.041-5.16107c-.81858-3.84412-1.71755-7.67934-2.68733-11.479-.48055-1.922-.99673-3.84412-1.5216-5.75725v-.0089a298.06057,298.06057,0,0,0-275.406-217.682h-.02694q-5.72619-.22689-11.47887-.22246c-1.05017,0-2.09991.0089-3.14095.02672a298.01494,298.01494,0,0,0-283.4502,216.7565q-.8277,2.90977-1.575,5.83736c-.99673,3.83521-1.90439,7.68824-2.74991,11.56794v.00891c-.37367,1.7352-.72951,3.46149-1.07667,5.19669a300.75146,300.75146,0,0,0-5.65928,58.25791c0,7.46579.27591,14.94042.82771,22.27277.07995,1.05.1599,2.1.249,3.14111.21377,2.625.48055,5.35686.79208,8.13316a297.724,297.724,0,0,0,575.20225,69.24749q3.08339-8.369,5.64189-16.907A292.93744,292.93744,0,0,0,730.54,407.58951q.73386-4.96536,1.29-9.94843c.31153-2.7763.57831-5.50812.79208-8.12426.7117-8.33781,1.07667-16.88917,1.07667-25.42278A300.6001,300.6001,0,0,0,728.2085,306.75264Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M505.80112,122.95185a.78188.78188,0,1,1,0-1.56375h51.75557a24.73488,24.73488,0,0,1,23.92992-18.90433,34.39771,34.39771,0,0,1,62.4781-7.33771c.76908-.05994,1.52356-.0901,2.249-.0901a29.20187,29.20187,0,0,1,29.04408,27.05923.78181.78181,0,0,1-.72527.83475c-.01862.00134-.03713.00191-.05555.00191a.78183.78183,0,0,1-.77911-.72709Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M665.1742,132.97688H536.94677a.78188.78188,0,0,1,0-1.56375H665.1742a.78188.78188,0,0,1,0,1.56375Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.08093,
    y: 322.15016,
    width: 35.59086,
    height: 82.50607,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 518.43769,
    y: 322.15016,
    width: 35.59086,
    height: 82.50607,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M714.21131,466.42583c-41.65354,113.22345-150.481,193.98548-278.16459,193.98548s-236.511-80.762-278.16459-193.98548Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#f9a826"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.33179,
    cy: 149.93832,
    r: 102.33179,
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M728.2085,306.75264q-.494-2.58944-1.041-5.16107c-.81858-3.84412-1.71755-7.67934-2.68733-11.479-.48055-1.922-.99673-3.84412-1.5216-5.75725v-.0089a298.06057,298.06057,0,0,0-275.406-217.682h-.02694q-5.72619-.22689-11.47887-.22246c-1.05017,0-2.09991.0089-3.14095.02672a298.01494,298.01494,0,0,0-283.4502,216.7565q-.8277,2.90977-1.575,5.83736c-.99673,3.83521-1.90439,7.68824-2.74991,11.56794v.00891c-.37367,1.7352-.72951,3.46149-1.07667,5.19669a300.75146,300.75146,0,0,0-5.65928,58.25791c0,7.46579.27591,14.94042.82771,22.27277.07995,1.05.1599,2.1.249,3.14111.21377,2.625.48055,5.35686.79208,8.13316a297.724,297.724,0,0,0,575.20225,69.24749q3.08339-8.369,5.64189-16.907A292.93744,292.93744,0,0,0,730.54,407.58951q.73386-4.96536,1.29-9.94843c.31153-2.7763.57831-5.50812.79208-8.12426.7117-8.33781,1.07667-16.88917,1.07667-25.42278A300.6001,300.6001,0,0,0,728.2085,306.75264Zm1.75274,82.54172c-.20464,2.58942-.47142,5.30348-.783,8.04415q-.5605,4.952-1.2722,9.87728a293.97505,293.97505,0,0,1-9.35246,42.0183q-2.54961,8.44907-5.59714,16.729C670.46655,581.47344,559.1829,659.07655,436.04672,659.07655S201.62688,581.47344,159.137,465.9631a293.11653,293.11653,0,0,1-16.2218-68.62459c-.31153-2.74067-.57831-5.45473-.79208-8.053-.08907-1.0322-.169-2.06444-.249-3.10554-.534-7.27-.80989-14.6913-.80989-22.08588a294.59441,294.59441,0,0,1,6.38922-61.20333c.37366-1.78854.77383-3.56822,1.17443-5.34791v-.0089q1.41493-6.03315,3.05232-11.97729c.1512-.5517.3024-1.1034.46273-1.64619q.21312-.78755.45361-1.575c.26678-.96105.55181-1.91319.8364-2.85641,36.172-120.60022,147.59814-208.9793,279.49066-210.34963,1.041-.00891,2.08209-.01782,3.12314-.01782q5.71314,0,11.3898.21356c128.689,4.91194,236.52886,92.66812,271.57985,211.33739q.88114,2.98986,1.70842,6.01534c1.068,3.91532,2.05559,7.87507,2.96324,11.8527q.60091,2.64279,1.14794,5.31232a294.27871,294.27871,0,0,1,6.19326,60.2512C731.02923,372.54754,730.67338,381.02776,729.96124,389.29436Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.12535,
    y: 274.42606,
    width: 27.50202,
    height: 51.76852,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.16976,
    y: 162.80019,
    width: 6.47106,
    height: 116.47916,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.11189,
    y: 162.80019,
    width: 6.47106,
    height: 116.47916,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4053,
    y: 167.65349,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4053,
    y: 200.00881,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4053,
    y: 235.59967,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76.78753,
    y: 157.94689,
    width: 3.23553,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 89.72966,
    y: 157.94689,
    width: 3.23553,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 522.48211,
    y: 274.42606,
    width: 27.50202,
    height: 51.76852,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 526.52652,
    y: 162.80019,
    width: 6.47106,
    height: 116.47916,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 539.46865,
    y: 162.80019,
    width: 6.47106,
    height: 116.47916,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 529.76205,
    y: 167.65349,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 529.76205,
    y: 200.00881,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 529.76205,
    y: 235.59967,
    width: 14.5599,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 528.14429,
    y: 157.94689,
    width: 3.23553,
    height: 8.08883,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 541.08642,
    y: 157.94689,
    width: 3.23553,
    height: 8.08883,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M731.296,389.40114q-.33369,4.071-.79165,8.08869H141.58908q-.45362-4.01766-.79165-8.08869Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M440.48057,376.816c-77.56628,0-157.56711-50.37825-237.842-149.79267L205.156,224.99c80.743,99.99581,161.01236,150.0178,238.534,148.56118,75.35015-1.37684,150.44909-51.34433,223.21105-148.51457l2.59016,1.94006c-73.39152,98.01072-149.342,148.41345-225.742,149.81Q442.1159,376.81637,440.48057,376.816Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M440.2349,365.94265c-73.26672,0-148.82659-46.71616-224.64516-138.90829l2.49933-2.05538c76.24749,92.71427,152.00445,139.0173,225.24471,137.6997,71.10153-1.30495,141.96885-47.61825,210.63386-137.6531l2.57279,1.96217C587.24585,317.84807,515.53252,364.5903,443.393,365.91421,442.34163,365.93317,441.28708,365.94265,440.2349,365.94265Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M728.2085,306.75264c-1.12143-.961-2.25154-1.93094-3.37253-2.9098q-36.31884-31.62053-72.82451-76.82l2.51832-2.02886q34.66343,42.93928,69.15825,73.53653,1.73494,1.54828,3.47942,3.061Q727.71426,304.16766,728.2085,306.75264Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M724.48012,290.11259q-1.88223-1.68182-3.75533-3.43477a596.91841,596.91841,0,0,1-55.7663-59.64611l2.5005-2.05554a603.15817,603.15817,0,0,0,51.55738,55.68631c1.31694,1.25471,2.6252,2.48269,3.94215,3.684v.0089C723.48339,286.26847,723.99957,288.19056,724.48012,290.11259Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 111.75158,
    y: 185.0895,
    width: 3.23553,
    height: 140.29619,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 141.85246,
    y: 215.88946,
    width: 3.23553,
    height: 109.49623,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 182.85272,
    y: 250.13113,
    width: 3.23553,
    height: 76.06345,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 222.1029,
    y: 274.42606,
    width: 3.23553,
    height: 50.95963,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 254.6719,
    y: 288.16285,
    width: 3.23553,
    height: 38.84061,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 560.23178,
    y: 185.0895,
    width: 3.23553,
    height: 140.29619,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 590.33265,
    y: 215.88946,
    width: 3.23553,
    height: 109.49623,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.19213,227.02285q-16.87092,20.889-33.71578,38.90385-1.6287,1.72182-3.23,3.42593-13.45451,14.13509-26.8647,26.42825-1.628,1.49493-3.23871,2.94537c-1.56635,1.406-3.12357,2.79412-4.68948,4.16446-.365.32038-.72083.64071-1.0858.95213-.76514.66739-1.53941,1.33477-2.31367,1.99329.34716-1.7352.703-3.46149,1.07667-5.19669v-.00891c.8012-.6852,1.59285-1.38815,2.38493-2.1.37366-.32924.73864-.65848,1.1123-.98772v-.0089q1.76166-1.56165,3.51505-3.16784,1.628-1.46829,3.23871-2.981,13.41476-12.42663,26.8647-26.75754c1.07668-1.14788,2.15335-2.29576,3.23-3.46145q15.5896-16.83141,31.1979-36.17208Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M206.24511,227.03171q-10.55819,12.84048-21.09811,24.49736c-.96979,1.06782-1.93089,2.12674-2.90068,3.17674q-13.57507,14.80248-27.13148,27.62958-1.49508,1.41484-2.97193,2.79411c-.1512.15126-.31153.29367-.46273.42711-.40061.38262-.80077.74749-1.20138,1.12121-.86333.80973-1.72624,1.6017-2.59826,2.38477q.74754-2.92314,1.575-5.83736,1.37452-1.25469,2.73166-2.56275c.41842-.39153.82771-.78307,1.24569-1.1835q13.98828-13.28083,28.00351-28.68849,11.14539-12.25311,22.30817-25.81432Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 56.75233,
    y: 185.0895,
    width: 3.23553,
    height: 140.29619,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 26.65145,
    y: 215.88946,
    width: 3.23553,
    height: 109.49623,
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 510.97566,
    y: 181.85397,
    width: 3.23553,
    height: 143.53172,
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 480.87479,
    y: 215.88946,
    width: 3.23553,
    height: 109.49623,
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 439.87453,
    y: 250.13113,
    width: 3.23553,
    height: 76.06345,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 400.62434,
    y: 274.42606,
    width: 3.23553,
    height: 50.95963,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 368.05535,
    y: 288.16285,
    width: 3.23553,
    height: 38.84061,
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 305.33136,
    y: 297.71067,
    width: 3.23553,
    height: 29.29278,
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M413.44081,545.07971H338.64545a4.3521,4.3521,0,1,1,0-8.7042h74.79536a4.3521,4.3521,0,1,1,0,8.7042Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M533.448,518.28735H458.65285a4.3521,4.3521,0,1,1,0-8.7042H533.448a4.3521,4.3521,0,1,1,0,8.7042Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M484.83844,582.55017H410.04307a4.3521,4.3521,0,1,1,0-8.7042h74.79537a4.3521,4.3521,0,0,1,0,8.7042Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.80112,197.95185a.78188.78188,0,1,1,0-1.56375h51.75557a24.73488,24.73488,0,0,1,23.92992-18.90433,34.39771,34.39771,0,0,1,62.4781-7.33771c.76908-.05994,1.52356-.0901,2.249-.0901a29.20187,29.20187,0,0,1,29.04408,27.05923.78181.78181,0,0,1-.72527.83475c-.01862.00134-.03713.00191-.05555.00191a.78183.78183,0,0,1-.77911-.72709Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M424.22175,219.31406h-43.0031a.78188.78188,0,0,1,0-1.56375h43.0031a.78188.78188,0,1,1,0,1.56375Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M448.60063,112.03682l6.50237-5.20066c-5.05142-.55731-7.127,2.19763-7.97639,4.37816-3.94636-1.63868-8.24245.50889-8.24245.50889l13.01006,4.72312A9.84517,9.84517,0,0,0,448.60063,112.03682Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M471.73652,247.29275l6.50236-5.20066c-5.05142-.55731-7.127,2.19763-7.97638,4.37817-3.94637-1.63868-8.24246.50888-8.24246.50888l13.01006,4.72313A9.84523,9.84523,0,0,0,471.73652,247.29275Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M623.89944,196.57178l6.50236-5.20067c-5.05142-.5573-7.12694,2.19763-7.97638,4.37817-3.94636-1.63868-8.24246.50889-8.24246.50889l13.01006,4.72312A9.84507,9.84507,0,0,0,623.89944,196.57178Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 51.61082,
    y: 389.30573,
    width: 63.17876,
    height: 10.6781,
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 504.54022,
    y: 389.30573,
    width: 63.17876,
    height: 10.6781,
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 14.73018,
    y: 315.14559,
    width: 591.54571,
    height: 2.66952,
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.2712,833.558H602.04236a1.23682,1.23682,0,0,1,0-2.47364H1073.2712a1.23682,1.23682,0,1,1,0,2.47364Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#cacaca"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M869.2834,288.54672H828.45149a3.15256,3.15256,0,0,1-3.12374-2.75822l-.52878-4.22894a1.88868,1.88868,0,0,0-3.5858-.56444l-2.67675,5.73533a3.16022,3.16022,0,0,1-2.8526,1.81627h-6.2023a3.14746,3.14746,0,0,1-3.1339-3.44808l2.44557-25.54458a3.1722,3.1722,0,0,1,1.799-2.56392c18.69975-8.72965,37.66266-8.71858,56.36241.0332a3.15258,3.15258,0,0,1,1.78122,2.41636l3.66359,25.51137a3.14716,3.14716,0,0,1-3.11606,3.59565Z",
    transform: "translate(-125.49198 -66.44201)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.422b9495b6145cb985a33ef8f7e2a2fd.svg";
export { ForwardRef as ReactComponent };